"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCredentialsFromUrl = void 0;
var tslib_1 = require("tslib");
function setCredentialsFromUrl(credentials) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var query, accessToken, refreshToken, exchangeToken, asCompany, asUser;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    query = new URLSearchParams(location.search);
                    accessToken = query.get('accessToken');
                    refreshToken = query.get('refreshToken');
                    exchangeToken = query.get('exchangeToken');
                    asCompany = query.get('asCompany');
                    asUser = query.get('asUser');
                    if (!accessToken) return [3 /*break*/, 2];
                    return [4 /*yield*/, credentials.setAccessToken(accessToken)];
                case 1:
                    _a.sent();
                    query.delete('accessToken');
                    _a.label = 2;
                case 2:
                    if (!refreshToken) return [3 /*break*/, 4];
                    return [4 /*yield*/, credentials.setRefreshToken(refreshToken)];
                case 3:
                    _a.sent();
                    query.delete('refreshToken');
                    _a.label = 4;
                case 4:
                    if (!exchangeToken) return [3 /*break*/, 6];
                    return [4 /*yield*/, credentials.setExchangeToken(exchangeToken)];
                case 5:
                    _a.sent();
                    query.delete('exchangeToken');
                    _a.label = 6;
                case 6:
                    if (!asCompany) return [3 /*break*/, 8];
                    return [4 /*yield*/, credentials.setDelegateCompany(asCompany)];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8:
                    if (!asUser) return [3 /*break*/, 10];
                    return [4 /*yield*/, credentials.setDelegateUser(asUser)];
                case 9:
                    _a.sent();
                    _a.label = 10;
                case 10: return [2 /*return*/];
            }
        });
    });
}
exports.setCredentialsFromUrl = setCredentialsFromUrl;
